import { CustomHeader, Screen, Text, TextInput } from "components"
import React, { useRef, useState } from "react"
import {
  ActivityIndicator,
  FlatList,
  Image,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { useNavigation } from "@react-navigation/native"
import { style } from "./styles"
import { TabView } from "react-native-tab-view"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import { colors } from "colors"
import Feather from "@expo/vector-icons/Feather"
import { useStores } from "models"
import { typography } from "theme"
import { sortBy } from "lodash"
import { observer } from "mobx-react-lite"
import useResponsiveWidth from "components/fitSize"

import larrie1 from "../../../../assets/images/larrie-promo1.jpg"
import larrie2 from "../../../../assets/images/larrie-promo2.jpg"
import larrie3 from "../../../../assets/images/larrie-promo3.png"
import { useColor } from "app/theme/getThemes"

export const CouponScreen = observer(() => {
  const navigation = useNavigation<any>()
  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()
  const { couponStore } = useStores()

  const [index, setIndex] = useState(0)
  const [routes] = useState([
    { key: "first", title: "Browse" },
    { key: "second", title: "Saved" },
  ])

  // couponHistory updated to an array for consistency
  const [couponHistory, setCouponHistory] = useState([
    {
      couponStatus: 1,
      description: `Happy Father’s Day! Celebrate Father’s Day in grandeur! Elevate Dad’s day with Larrie’s exclusive Father’s Day Special Promotion. Treat him to the ideal footwear for occasion.`,
      end_at: "-",
      img_full_url: larrie2,
      coupon_id: 2,
      coupon_name: "Father Days Free Bags",
      start_at: "-",
      tnc: "Get a complimentary drink with the Merdeka Special Set when showing this voucher. Limited to one redemption per customer per visit. Cannot be combined with other offers.",
    },
  ])

  const [couponList] = useState([
    {
      description: `Spend & win a dream vacation!
  Contest Period : 1 Sept - 31 Oct 2024
  To participate in this contest please follow the steps in the visual provided above.`,
      end_at: "2024-10-31 00:00:00",
      img_full_url: larrie1,
      coupon_id: 1,
      coupon_name: "TRAVEL WITH US",
      start_at: "2024-09-01 00:00:00",
      tnc: "*Term and condition apply.",
    },
    {
      description: `Happy Father’s Day! Celebrate Father’s Day in grandeur! Elevate Dad’s day with Larrie’s exclusive Father’s Day Special Promotion. Treat him to the ideal footwear for occasion.`,
      end_at: "-",
      img_full_url: larrie2,
      coupon_id: 2,
      coupon_name: "Father Days Free Bags",
      start_at: "-",
      tnc: "Get a complimentary drink with the Merdeka Special Set when showing this voucher. Limited to one redemption per customer per visit. Cannot be combined with other offers.",
    },
    {
      description:
        "LARRIE Merdeka Shoes Fair! 👞🎉 Get your favorite shoes with discounts up to 50% off! Join us at the West Concourse, SOGO Central i-City, and explore a variety of quality shoe brands such as Larrie, Alain Delon, Polo, Crocodile, and more. Don’t miss out on this incredible offer!",
      end_at: "2024-09-13 23:59:59",
      img_full_url: larrie3,
      coupon_id: 3,
      coupon_name: "MERDEKA SHOES FAIR",
      start_at: "2024-08-23 00:00:00",
      tnc: "Terms and conditions apply. Discounts are available while stocks last.",
    },
  ])

  const [loading, setLoading] = useState(false)
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [searchText, setSearchText] = useState("")
  const searchTextRef = useRef()
  const { companyTheme } = useColor()

  // FirstRoute displays couponList
  const FirstRoute = () => (
    <Content
      data={
        searchText
          ? couponList?.filter((item) => item?.coupon_name.includes(searchText))
          : couponList
      }
    />
  )

  // SecondRoute displays couponHistory
  const SecondRoute = () => (
    <Content
      data={
        searchText
          ? couponHistory?.filter((item) => item?.coupon_name.includes(searchText))
          : couponHistory
      }
    />
  )

  const Content = ({ data }) => (
    <FlatList
      data={data}
      contentContainerStyle={style.flex}
      numColumns={2}
      style={style.flatList}
      ListEmptyComponent={() => (
        <View style={style.emptyContainer}>
          {loading ? (
            <ActivityIndicator size="large" color={companyTheme.first} />
          ) : (
            <>
              <Text style={style.emptyTitle}>{translate("promotionScreen.noPromotion")}</Text>
              <Text>{translate("promotionScreen.stayTuned")}</Text>
            </>
          )}
        </View>
      )}
      columnWrapperStyle={style.columnWrapper}
      renderItem={({ item }) => {
        const itemUsed = item?.couponStatus === "used"
        return (
          <TouchableOpacity
            onPress={() => navigation.navigate("couponDetail", { item })}
            style={style.contentContainer}
          >
            <View>
              {itemUsed ? (
                <View>
                  <Image
                    source={{ uri: item?.img_full_url }}
                    style={[style.image, { width: width * 0.4, height: width * 0.4, opacity: 0.4 }]}
                  />
                  <Text
                    style={{
                      position: "absolute",
                      fontFamily: typography.primary.normal,
                      fontSize: 35,
                      alignSelf: "center",
                      justifyContent: "center",
                      top: "40%",
                      color: colors.error,
                      transform: [{ rotate: "-45deg" }],
                    }}
                  >
                    Used
                  </Text>
                </View>
              ) : (
                <Image
                  source={{ uri: item?.img_full_url }}
                  style={[style.image, { width: width * 0.4, height: width * 0.4 }]}
                />
              )}
            </View>
            <View style={style.contentTitleText}>
              <Text numberOfLines={2}>{item?.coupon_name}</Text>
              <Text
                style={{ fontFamily: typography.primary.normal, fontSize: 11 }}
                numberOfLines={3}
              >
                {item?.description}
              </Text>
            </View>
          </TouchableOpacity>
        )
      }}
    />
  )

  return (
    <>
      <CustomHeader showBackButton headerTitle="For You" />
      <Screen>
        <View style={style.container}>
          {isSearchVisible && (
            <LinearGradient
              style={{ paddingHorizontal: 20 }}
              colors={[companyTheme.first, companyTheme.second]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
            >
              <TextInput
                textFieldContainer={{ borderRadius: 10 }}
                textFieldStyle={{ height: 40 }}
                autoFocus
                textRef={searchTextRef}
                rightIcon={() => (
                  <Feather
                    onPress={() =>
                      searchTextRef?.current && setSearchText(searchTextRef?.current?.value)
                    }
                    name="search"
                    size={30}
                    color={companyTheme.first}
                  />
                )}
                onSubmitEditing={(e) => setSearchText(e?.nativeEvent?.text)}
                placeholder={translate("promotionScreen.promotionName")}
              />
            </LinearGradient>
          )}
          <TabView
            swipeEnabled={false}
            animationEnabled={false}
            renderTabBar={(props) => (
              <LinearGradient
                style={[style.linearGradient, { height: 60 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <View style={style.headerTabBarContainer}>
                  {props.navigationState.routes.map((route, i) => (
                    <TouchableOpacity
                      key={i}
                      onPress={() => setIndex(i)}
                      style={[style.tabBar, index === i && style.selectedTabBar]}
                    >
                      <Text
                        style={
                          index === i
                            ? { color: companyTheme.first, fontWeight: "bold" }
                            : { color: colors.white }
                        }
                      >
                        {route.title}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </LinearGradient>
            )}
            navigationState={{ index, routes }}
            renderScene={({ route }) => {
              switch (route.key) {
                case "first":
                  return FirstRoute()
                default:
                  return SecondRoute()
              }
            }}
            onIndexChange={setIndex}
            initialLayout={{ width }}
          />
        </View>
      </Screen>
    </>
  )
})
